import {
  VolleyballCardsAttribute,
  VolleyballIncidentId,
} from '@collector/sportsapi-client-legacy'
import { PopupBuilder } from '@mobile/views/Relation/Shared/Popup/builder/PopupBuilder'

export const RedCardPopup = new PopupBuilder('RedCard', {
  incident_id: VolleyballIncidentId.Cards,
  attribute_ids: [VolleyballCardsAttribute.RedCard],
})
  .withTeamSelection()
  .omitDetailsView()
  .build()
